import PropTypes from 'prop-types';
import React from 'react';
import { Formik, Field } from 'formik';
import moment from 'moment';
import { Dropdown, Button, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const Tardy = ({ data, sendRequest, tardyApproval }) => {
  const permissions = useSelector((state) => state.permissionsReducer);
  const renderDropdown = (
    label,
    content,
    iconClass = 'mdi-check-circle',
    iconColor = ''
  ) => (
    <Dropdown>
      <Dropdown.Toggle
        as={Button}
        size="sm"
        variant="white"
        className="text-muted border mt-2"
      >
        <i
          className={`mdi ${iconClass} me-1`}
          style={iconColor ? { color: iconColor } : {}}
        />
        {label}
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="dropdown-menu-right p-3 mt-1"
        style={{ minWidth: '300px' }}
      >
        {content}
      </Dropdown.Menu>
    </Dropdown>
  );

  const approvalHistory = (param) => {
    const logs = param.activityData?.tardyLogs || [];
    const pendingLog = logs[0];
    const approvedLog = logs[1];

    return (
      <>
        {pendingLog?.status === 'pending' && pendingLog?.updatedUserName && (
          <div>
            <span className="text-muted">
              {moment(pendingLog.updatedDate).format('MMM D h:mm a')} requested
              by
            </span>{' '}
            {pendingLog.updatedUserName}
          </div>
        )}

        {approvedLog?.status === 'approved' && approvedLog?.updatedUserName && (
          <div>
            <span className="text-muted">
              {moment(approvedLog.updatedDate).format('MMM D h:mm a')} approved
              by
            </span>{' '}
            {approvedLog.updatedUserName}
          </div>
        )}
        {approvedLog?.status === 'rejected' && approvedLog?.updatedUserName && (
          <div>
            <span className="text-muted">
              {moment(approvedLog.updatedDate).format('MMM D h:mm a')} Rejected
              by
            </span>{' '}
            {approvedLog.updatedUserName}
          </div>
        )}
        {(param.activityData?.tardyStatus === 'pending' ||
          param.activityData?.tardyStatus === 'approved' ||
          param.activityData?.tardyStatus === 'rejected') && (
          <div className="mb-2">
            {logs[param.activityData.tardyStatus === 'pending' ? 0 : 1]
              ?.note && (
              <>
                <span className="text-muted">Note:</span>{' '}
                {
                  logs[param.activityData.tardyStatus === 'pending' ? 0 : 1]
                    .note
                }
              </>
            )}
          </div>
        )}
      </>
    );
  };

  const approvalForm = (
    <Formik initialValues={{ note: '' }} onSubmit={() => {}}>
      {(formikprops) => (
        <Form onSubmit={formikprops.handleSubmit}>
          <Button
            onClick={() =>
              tardyApproval({
                data,
                status: 'approved',
              })
            }
            variant="primary"
            type="submit"
            size="sm"
            className="me-2"
          >
            Approve
          </Button>
          <Button
            onClick={() =>
              tardyApproval({
                data,
                status: 'rejected',
              })
            }
            variant="danger"
            type="submit"
            size="sm"
          >
            Reject
          </Button>
          <hr />
          {approvalHistory(data)}
        </Form>
      )}
    </Formik>
  );

  const requestForm = (
    <Formik initialValues={{ note: '' }} onSubmit={() => {}}>
      {(formikprops) => (
        <Form onSubmit={formikprops.handleSubmit}>
          <Form.Group controlId="wsNotes" className="mb-3">
            <Field
              as="textarea"
              maxLength="300"
              name="note"
              rows="2"
              className="form-control"
              placeholder="Notes"
            />
          </Form.Group>
          <Button
            variant="primary"
            type="submit"
            size="sm"
            className="me-2"
            onClick={() =>
              sendRequest({
                note: formikprops.values.note,
                teamMemberId: data.userId,
                scheduleId: data._id,
                scheduleDate: data.activityData.date.split('T')[0],
              })
            }
          >
            Send
          </Button>
        </Form>
      )}
    </Formik>
  );

  if (data.activityData.tardyStatus === 'approved') {
    return renderDropdown(
      'Approved',
      approvalHistory(data),
      'mdi-check-circle',
      '#28a745'
    );
  }
  if (data.activityData.tardyStatus === 'rejected') {
    return renderDropdown(
      'Rejected',
      approvalHistory(data),
      'mdi-check-circle',
      '#dc3545'
    );
  }
  if (
    permissions &&
    permissions.includes('tardy_approval') &&
    data.activityData.tardyStatus === 'pending'
  ) {
    return renderDropdown('Tardy Approval', approvalForm);
  }

  if (
    permissions &&
    permissions.includes('tardy_request') &&
    data.activityData.tardyStatus === 'pending'
  ) {
    return renderDropdown(
      'Requested',
      <div className="mb-2">
        <span className="text-muted">Note:</span>{' '}
        {data.activityData?.tardyLogs?.[0]?.note || '—'}
      </div>,
      'mdi-check-circle',
      '#ffc107'
    );
  }

  if (
    permissions &&
    permissions.includes('tardy_request') &&
    !data.activityData.tardyLogs
  ) {
    return renderDropdown('Tardy Request', requestForm);
  }

  return null;
};

Tardy.propTypes = {
  data: PropTypes.object,
  sendRequest: PropTypes.func,
  tardyApproval: PropTypes.func,
};

export default Tardy;
